import customHeaders, { getSpace } from '../../common/headers'
import arrow_right from './img/arrow_right.svg'
import { RavshanHttps } from '../../fetchUrls'
import { useState } from 'react'
import useGeneralStore from '../../store/general'
import { useShallow } from 'zustand/react/shallow'
import { AuthorAvatar } from '../../pages/ArticleComponents/AuthorAvatar/AuthorAvatar'
import './NotificationListItem.scss'

const NotificationListItem = ({ ...props }) => {
    const {
        id,
        author,
        notification_text,
        name,
        created_at,
        activeChat,
        setActiveChat,
        fetchGetNotificationsByPortal,
        readed,
        updateCount
    } = props
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const [statusRead, setStatusRead] = useState(readed)

      const {
        isChangeNotification,
        setIsChangeNotification,
      } = useGeneralStore(
        useShallow((state) => ({
          isChangeNotification: state.isChangeNotification,
          setIsChangeNotification: state.setIsChangeNotification,
        }))
      );

    const fetchChangeStatusRead = (id) => {
        let url = ` https://portals.ecomru.ru/api/v2/article/mark_read?article_id=${id}&read_all=${'false'}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                setStatusRead(true);
                setTimeout(() => updateCount(), 100)
                setIsChangeNotification(!isChangeNotification)
            })
            .catch((err) => console.error(err));
    };

    const fetchNotificationsCount = () => {
        let  url = `${RavshanHttps}/get_count_unread_msg`
        
        fetch(url, { method: 'GET', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(({ count }) => {
                // setNotifCount(count)
            })
            .catch(err => console.error(err))
    }

    return (
        < li className={activeChat?.id == id ? "message-notification__item_active" : "message-notification__item"}
            onClick={async (e) => {
                setActiveChat({ id })
                if (!statusRead) {
                    await fetchChangeStatusRead(id)
                    setTimeout(() => {
                        fetchGetNotificationsByPortal()
                        fetchNotificationsCount()
                    }, 100)
                }
            }}
        >
            <AuthorAvatar author={author?.[0] ? author : []} />

            <div className='message-notification__message-box'>
                <div className='message-notification__title-and-date'>
                    <p className='text'>{name?.[0] ? name?.[0] : 'Неизвестное название'}</p>

                    <div className='message-notification__info-message'>
                        <h5 className='message-notification__text'>{notification_text ? notification_text : 'Неизвестный текст'}</h5>
                        <p className='message-notification__date'>{created_at}</p>
                    </div>
                </div>
            </div>
            {statusRead ?
                <div className='message-notification__read-message'>
                    <img src={arrow_right} />
                </div>
                :
                <span className='message-notification__new-message'></span>}
        </li>
    )
}

export default NotificationListItem